module.exports = __webpack_public_path__ + "static/img/error.cb50f818.png";